import React, { Component } from 'react'
import { first, size, some } from 'lodash'
import menuRouteUtil from '../utils/menuRoute.util'
import MenuItem from './MenuItem'
import menuRoutes, { MenuRoute } from '../routes/menuRoutes'

interface MenuItemsProps {
  fold: boolean
  permittedModules: string[]
  onRoute: (to?: string) => void
}

export default class MenuItems extends Component<MenuItemsProps> {
  get className () {
    const base = 'grid'
    const fold = this.props.fold ? 'grid-cols-2' : 'grid-cols-3'
    return `${base} ${fold}`
  }

  /**
   * Where a group's icon should actually take the user.
   *
   * A group's own `to` is a fixed default - Management points at /items -
   * that the signed-in user may not be permitted to open: a label builder
   * site has no items module. Landing on an unpermitted route lets
   * ProtectedRoute's permission check fire and push the user to their first
   * permitted module, which throws them out of the group altogether
   * (Management -> system labels). Open the first route the group actually
   * permits instead.
   */
  groupTarget (groupPath: string, subsidiaries?: MenuRoute[]) {
    const isPermitted = some(subsidiaries, sub => sub.to === groupPath)
    if (isPermitted) return groupPath
    const fallback = first(subsidiaries)
    return fallback ? fallback.to : groupPath
  }

  get items () {
    return (
      menuRoutes.map(group => {
        const subsidiaries = menuRouteUtil.collectPermittedCombinedSubsidiaries(
          group.name,
          this.props.permittedModules
        )
        if (!size(subsidiaries)) return null
        return (
          <MenuItem
            text={group.text}
            icon={group.icon}
            to={this.groupTarget(group.to, subsidiaries)}
            groupPath={group.to}
            onRoute={this.props.onRoute}
            key={group.to} />
        )
      })
    )
  }

  render () {
    return (
      <div className='border-t border-b border-white border-opacity-30 py-3'>
        <div className={this.className}>
          {this.items}
        </div>
      </div>
    )
  }
}
